const languageLevelCodes = ['A1', 'A2', 'B1', 'B2', 'C1', 'C2', 'NATIVE'];

const languageLevels = languageLevelCodes.map((levelCode) => ({
  id: levelCode,
  name: levelCode,
}));

export default languageLevels;
